import React, { useState, useEffect, useRef } from 'react'
import {
    Flex, Button, Input, theme, Avatar, Divider, Tag, 
    Radio,
    Drawer, Row, Col, Typography,
    Card
} from 'antd'
import {
    ClockCircleFilled, CommentOutlined, EnvironmentOutlined, InfoCircleFilled, LeftOutlined,
    MinusOutlined, PlusOutlined, CheckOutlined
} from '@ant-design/icons'
import './delivery.css'
import LOGO from '../../img/lion-head.png'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ENTREGA_ICON from '../../img/entrega.png'
import { getMenu } from '../../services/bd/cardapioDigital'
import { useToasts } from 'react-toast-notifications'
import { useParams,  useOutletContext } from 'react-router-dom';
import WHATSHAP from '../../img/whatshap.png'
import { horarioToSegundos, segundosToHorario } from '../../services/util'
import dayjs from 'dayjs'
import { Image, Placeholder } from 'rsuite'
import { useRecoilState } from 'recoil'
import { deliveryPedidosState } from '../../store/recoilData'
import NOIMAGE from '../../img/notimage.png'
import { BASEURLRAIZ } from '../../services/api.service'


export const Delivery = (props) => {

    const [pedidoDelivery, setPedidoDelivery] = useRecoilState(deliveryPedidosState)
    const meuElementoRef = useRef(null);
    const [estaNaTela, ] = useState(true);

    const [openInfo, setOpenInfo] = useState(false)
    const { nome } = useParams()
    const { addToast } = useToasts()
    const [, setLoadingCardapio] = useState(false)
    const [app] = useOutletContext();

    const [itemSelected, setItemSelected] = useState(undefined)
    const [openSelected, setOpenSelected] = useState(false)
    const [selectedValided, setSelectedValidad] = useState(false)



    const [menu, setMenu] = useState({
        destaques: [],
        cetegorias: []
    })

    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();

    const settings = {
        className: "slider variable-width",
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 3,
        variableWidth: true,

    };

    useEffect(() => {
     //   console.log('context mudou')
    }, [app])

    useEffect(() => {
        //  console.log(BASEURLRAIZ.concat('banners/', app?.banner))
        if (nome) {

            let pedidos = JSON.parse(JSON.stringify({ ...pedidoDelivery }))
            //   console.log(pedidos)
            if (pedidos[nome]) {
                //    console.log(pedidos[nome].start, horarioToSegundos(dayjs()))
                if (pedidos[nome].start < horarioToSegundos(dayjs())) {
                    //   console.log('menor')
                    pedidos[nome].itens = []
                    pedidos[nome].start = horarioToSegundos(dayjs().add(30, 'minute'))
                    setPedidoDelivery(pedidos)
                }
            }

            loadMenu()
        }
    }, [])

    useEffect(() => {
        if (itemSelected) {
            validarGrupos()
        }
    }, [itemSelected])

    function validarGrupos() {
        let valided = true
        itemSelected?.groups?.map((grupo, indexgp) => {
            if (grupo.mandatory > 0) {
                if (!grupo.valided)
                    valided = false
            } else {
                grupo.valided = true
            }
        })
        setSelectedValidad(valided)
    }

    async function loadMenu() {
        try {
            setLoadingCardapio(true)
            const resp = await getMenu({ nome: nome })
            //  console.log(resp)
            setMenu(resp)
        } catch (error) {
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }
        setLoadingCardapio(false)
    }

    function renderPreco(item) {

        if (item?.ispattern === 0) {
            return <Flex align='center' gap={2} >
                <Flex style={{ color: '#50a773' }}>a partir R${item?.apartir}</Flex>
            </Flex>

        } else if (item?.promotype === 0) {
            return <Flex gap={5} flex={1} style={{ lineHeight: 1 }} align='center'>
                <Flex justify='flex-start' style={{ color: '#50a773', fontWeight: 'inherit', fontSize: '1.1em' }}>R${item?.promovalue.toFixed(2)}</Flex>
                <Flex align='center' style={{ color: '#c0c0c0', fontSize: '.9em', textDecoration: 'line-through', lineHeight: 1 }} gap={4}>
                    R${parseFloat(item?.value).toFixed(2)}
                    {<Tag style={{ fontSize: '0.8em' }} color={app.cor}>
                        <b>-</b>{item.value > 0 ? (100 - (item.promovalue * 100 / item.value)).toFixed(0) : 100}{'%'}
                    </Tag>}

                </Flex>
            </Flex>
        } else {
            return <Flex flex={1}
                style={{ fontSize: '1.1em', fontWeight: 'inherit' }}>
                R${parseFloat(item?.value).toFixed(2)}
            </Flex>
        }
    }

    function addItem(it) {
        try {

            let item = JSON.parse(JSON.stringify(it))
            if (item.promotype === 0)
                item.value = item.promovalue

            item?.groups?.map((gp, indexgp) => {
                gp.items = gp.items.filter(value => value.sel > 0)
            })
            item?.groups?.map((gp, indexgp) => {
                gp.items.map((value) => {
                    if (value.promotype === 0)
                        value.value = parseFloat(value.promovalue)
                })
            })

            let pedidos = JSON.parse(JSON.stringify({ ...pedidoDelivery }))

            //  return
            if (!pedidos)
                pedidos = []

            if (!pedidos[nome]) {
                pedidos[nome] = {
                    start: horarioToSegundos(dayjs().add(30, 'minute')),
                    itens: []
                }



                console.log('aqui', pedidos)

                pedidos[nome].itens.push(item)
                //  console.log(pedidos[nome])

            } else {

                if (!pedidos[nome].itens) {
                    pedidos[nome] = {
                        start: horarioToSegundos(dayjs().add(30, 'minute')),
                        itens: []
                    }
                }

                if (pedidos[nome].itens?.length === 0)
                    pedidos[nome].start = horarioToSegundos(dayjs().add(30, 'minute'))
                pedidos[nome].itens.push(item)

            }
            setPedidoDelivery(pedidos)
            //    console.log(pedidos)

        } catch (error) {
            console.log(error.message)
        }
    }

    function sumItem() {
        var total = 0
        try {
            let vunit = itemSelected?.promotype === 0 ? parseFloat(itemSelected.promovalue) : parseFloat(itemSelected?.value)
            total = parseFloat(itemSelected?.quant) * vunit
            itemSelected?.groups?.map((gp, indexgp) => {
                gp.items?.map(item => {
                    if (item.sel > 0) {
                        total = total + parseFloat(itemSelected.quant) * (parseFloat(item.sel) * parseFloat(item.value))
                    }
                })
            })

        } catch (error) {

        }
        return total.toFixed(2)
    }

    function renderCorpoHeader() {
        return <Flex justify='space-between' style={{ marginBottom: 5, width: '100%' }} >
            <Flex vertical>
                <Flex gap={5} align='center'>
                    {app?.logo ? <Avatar size={'small'} src={BASEURLRAIZ + "logos/" + app?.logo} /> : <Avatar size={'small'} src={LOGO} />}
                    <Flex style={{ fontFamily: 'Raleway, sans-serif', color: '#181818ff', fontSize: '1.3em', fontWeight: 600 }}>
                        {app.fantasia}
                    </Flex>
                </Flex>

                <Flex align='center' gap={5}>
                    {/* <Badge status={app.status?.open ? "success" : 'error'} /> */}
                    <Flex justify='flex-start' style={{ minWidth: 100 }} gap={5}>
                        <Flex key={app.status?.open}> <Tag  color={app.status?.open ? "#87d068" : '#EA0813'}> {app.status?.open ? "Aberto" : 'Fechado'} </Tag></Flex>
                        {app.status?.open === false && app?.status?.mensagem && <Flex> - {app?.status?.mensagem} </Flex>}
                    </Flex>

                    <Flex align='center' gap={4} style={{ marginLeft: 25 }}>
                        <img height={14} width={14} alt='entrega' src={ENTREGA_ICON} />
                        <Flex>{app.entrega}</Flex>
                    </Flex>
                </Flex>
            </Flex>
            <Flex vertical justify='center' align='center'><InfoCircleFilled style={{ color: app.cor, fontSize: '1.4em' }}
                onClick={() => setOpenInfo(true)} /></Flex>
        </Flex>
    }

    return <div style={{ backgroundColor: 'white' }}>

        {estaNaTela ? <div>
            <div style={
                {
                    // backgroundImage: `url("https://media-cdn.tripadvisor.com/media/photo-s/12/4d/a8/e0/forno-a-lenha-no-preparo.jpg")`,
                    backgroundImage: `url(` + BASEURLRAIZ + 'banners/' + app?.banner + `)`,
                    backgroundSize: 'cover',
                    height: 140
                }}>

                <Card
                    ref={meuElementoRef}
                    size='small'
                    style={{
                        backgroundColor: 'whitesmoke',
                        position: 'relative',
                        top: 105,
                        marginLeft: 10,
                        marginRight: 10,
                    }}>
                    {renderCorpoHeader()}
                </Card>
            </div>
        </div>
            :
            <Flex className={estaNaTela && 'efeitoHeader'} style={{ position: 'sticky', top: 0, padding: 10, zIndex: 999999999, backgroundColor: '#fff' }}>
                {renderCorpoHeader()}
            </Flex>
        }


        <div
            style={{
                marginTop: 60,
                paddingLeft: 18,
                paddingRight: 18,
                paddingBottom: 70,
                paddingTop: 3,
                minHeight: 380,
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
            <Flex vertical style={{
                width: '100%',
                marginBottom: (nome && pedidoDelivery[nome]?.itens?.length > 0) ? 110 : 40
            }}>

                {menu?.destaques?.length > 0 && <Flex align='center' style={{ fontWeight: 600, marginTop: 5 }}>⭐ Destaques</Flex>}

                {menu?.destaques?.length > 0 && <div style={{ marginTop: 10, marginBottom: 15, width: "97%", justifyContent: 'center' }}>

                    <Row>
                        {
                            menu?.destaques?.map((dest, indexDes) => {
                                return <Col span={8} key={"dest-".concat(dest.products_id, '-', dest.name, '-', indexDes)}>
                                    <Flex vertical style={{ borderRadius: 15, margin: 5 }} gap={3} onClick={() => {
                                        dest.quant = 1
                                        setItemSelected(JSON.parse(JSON.stringify(dest)))
                                        setOpenSelected(true)
                                    }}>
                                        {dest.url ? <img style={{ width: '100%', borderRadius: 10 }} src={dest.url} alt={'urlds'.concat(indexDes)}/> :
                                            <img style={{ width: '100%', borderRadius: 10 }} src={LOGO} alt={'logo'}/>}
                                        <Flex>R${dest.value.toFixed(2)}</Flex>
                                        <Flex>{dest.name}</Flex>
                                    </Flex>
                                </Col>
                            })
                        }
                    </Row>
                </div>
                }

                {menu?.destaques.length > 0 && <Divider style={{ marginTop: 5, marginBottom: 15 }} />}

                {menu?.categorias?.length > 4 && <div style={{ marginTop: -5, marginBottom: 15, width: "97%", justifyContent: 'center' }}>
                    <Slider {...settings} >
                        {
                            menu?.categorias?.map((cat, index) => {

                                return <Flex
                                    wrap
                                    key={"catrender-".concat(index)}
                                    vertical
                                    gap={5}
                                    style={{
                                        margin: 5,
                                        cursor: 'pointer'
                                    }} onClick={() => {
                                        menu?.categorias?.map((cat, index) => {
                                            cat.check = false
                                        })
                                        cat.check = true
                                        setMenu({ ...menu })
                                    }}>
                                    <Flex style={{
                                        padding: 3, marginLeft: 5, marginRight: 5,
                                        borderRadius: 10, cursor: 'pointer'
                                    }} justify='center'>
                                        <Image
                                            height={50}
                                            rounded
                                            width={50}
                                            fallbackSrc={NOIMAGE}
                                            fit='cover'
                                            src={cat.url}
                                            placeholder={<Placeholder.Graph active />} />
                                    </Flex>
                                    <Flex justify='center' style={{ fontSize: '0.8em' }}>{cat.name}</Flex>
                                </Flex>

                            })
                        }
                    </Slider>
                </div>
                }


                {/*Categorias */}
                {
                    menu?.categorias?.map((cat, indexCat) => {
                        if (cat.itens.length > 0)
                            return <div key={"catprod".concat(cat.category_id)}>
                                {indexCat > 0 && <Divider style={{ marginBottom: 10, marginTop: 10 }} />}
                                <Flex style={{ fontWeight: 700, fontSize: '1.2em' }} href={"#cat".concat(cat.category_id)} id={cat.name}>{cat.name}</Flex>
                                {
                                    cat.itens.map((item, index) => {
                                        return <div key={'product-'.concat(index)}
                                            onClick={() => {

                                                if (app.status?.open === true) {
                                                    item.quant = 1
                                                    setItemSelected(JSON.parse(JSON.stringify(item)))
                                                    setOpenSelected(true)
                                                }
                                                else
                                                    addToast("O estabelecimento está fechado, não é possível efetuar o pedido!", { appearance: 'info', autoDismiss: true })



                                            }}>
                                            <Divider style={{ marginBottom: 10, marginTop: 10 }} />
                                            <Flex vertical key={'prod-'.concat(index)} flex={1} >
                                                <Flex justify='space-between' gap={10}>
                                                    <Flex vertical justify='space-between'>
                                                        <Flex vertical>
                                                            <Flex style={{ fontWeight: 500 }}>{item.ispattern === 0 ? item.nome : item.name}</Flex>
                                                            <Flex style={{ color: 'darkgray', fontSize: '0.9em' }}>
                                                                <Typography.Paragraph type='secondary'

                                                                    ellipsis={{
                                                                        rows: 3,
                                                                        expandable: 'collapsible',
                                                                        symbol: ''
                                                                    }}>
                                                                    {(item.ispattern === 0 && item.flavors > 1) ? "Até ".concat(item.flavors, ' sabores') : item.note}
                                                                </Typography.Paragraph>

                                                            </Flex>
                                                        </Flex>
                                                        <Flex align='center' gap={10} style={{ marginTop: 4, bottom: 0 }} >
                                                            {renderPreco(item)}
                                                        </Flex>
                                                    </Flex>
                                                    <Flex style={{ minWidth: 66 }}>
                                                        {/*item.url && <Avatar size={64} shape='square' src={item.url} />*/}

                                                        {
                                                            item.url && <Image
                                                                height={64}
                                                                rounded
                                                                width={64}
                                                                fallbackSrc={NOIMAGE}
                                                                fit='cover'
                                                                src={item.url}
                                                                placeholder={<Placeholder.Graph active />} />
                                                        }
                                                    </Flex>

                                                </Flex>


                                            </Flex>
                                        </div>
                                    })
                                }
                            </div>
                    })
                }
            </Flex>


            <Drawer
                closeIcon={<LeftOutlined style={{ color: app?.cor }} />}
                open={openInfo}
                width={"100%"}
                title={<Flex justify='center'>Sobre</Flex>}
                onClose={() => setOpenInfo(false)}
                closable={true}>
                <Flex vertical gap={5}>
                    <Flex style={{ fontWeight: 700, marginTop: 20, fontSize: '1.2em' }}>Contato</Flex>
                    <Flex align='center' gap={5}>
                        <Avatar size={'small'} shape='square' src={WHATSHAP} />
                        <Flex>{app.whatshap}</Flex>
                    </Flex>

                    <Flex style={{ fontWeight: 700, marginTop: 20, fontSize: '1.2em' }}>Pagamento na Entrega</Flex>
                    <Flex gap={5} align='center' wrap>
                        {
                            app?.pagamentos_offline?.map((item, index) => {
                                return <Tag key={item.name} bordered={false}>
                                    <Flex gap={3} align='center'>
                                        <img width={14} height={11} src={item.url} alt={'url'.concat(index)}/>
                                        {item.name}
                                    </Flex>
                                </Tag>
                            })

                        }
                    </Flex>

                    <Flex style={{ fontWeight: 700, marginTop: 20, fontSize: '1.2em' }}>Horários</Flex>
                    <Flex vertical>
                        <Flex justify='space-between' style={{ fontWeight: dayjs().day() === 0 ? 'bold' : 'normal' }}>
                            <Flex>Domingo</Flex>
                            <Flex gap={2}>
                                {app?.horarios?.filter(value => value.dia === 0).map((value, index) => {
                                    return <Flex style={{ marginRight: 5 }} key={JSON.stringify(value)}>
                                        {segundosToHorario(value.inicio)} às {segundosToHorario(value.termino)}</Flex>
                                })}
                            </Flex>
                        </Flex>
                        <Divider style={{ marginTop: 1, marginBottom: 1 }} />
                        <Flex justify='space-between' style={{ fontWeight: dayjs().day() === 1 ? 'bold' : 'normal' }}>
                            <Flex>Segunda</Flex>
                            <Flex gap={2}>
                                {app?.horarios?.filter(value => value.dia === 1).map((value, index) => {
                                    return <Flex style={{ marginRight: 5 }} key={JSON.stringify(value)}>
                                        {segundosToHorario(value.inicio)} às {segundosToHorario(value.termino)}</Flex>
                                })}
                            </Flex>
                        </Flex>
                        <Divider style={{ marginTop: 1, marginBottom: 1 }} />
                        <Flex justify='space-between' style={{ fontWeight: dayjs().day() === 2 ? 'bold' : 'normal' }}>
                            <Flex>Terça</Flex>
                            <Flex gap={2}>
                                {app?.horarios?.filter(value => value.dia === 2).map((value, index) => {
                                    return <Flex style={{ marginRight: 5 }} key={JSON.stringify(value)}>
                                        {segundosToHorario(value.inicio)} às {segundosToHorario(value.termino)}</Flex>
                                })}
                            </Flex>
                        </Flex>
                        <Divider style={{ marginTop: 1, marginBottom: 1 }} />
                        <Flex justify='space-between' style={{ fontWeight: dayjs().day() === 3 ? 'bold' : 'normal' }}>
                            <Flex>Quarta</Flex>
                            <Flex gap={2}>
                                {app?.horarios?.filter(value => value.dia === 3).map((value, index) => {
                                    return <Flex style={{ marginRight: 5 }} key={JSON.stringify(value)}>
                                        {segundosToHorario(value.inicio)} às {segundosToHorario(value.termino)}</Flex>
                                })}
                            </Flex>
                        </Flex>
                        <Divider style={{ marginTop: 1, marginBottom: 1 }} />
                        <Flex justify='space-between' style={{ fontWeight: dayjs().day() === 4 ? 'bold' : 'normal' }}>
                            <Flex>Quinta</Flex>
                            <Flex gap={2}>
                                {app?.horarios?.filter(value => value.dia === 4).map((value, index) => {
                                    return <Flex style={{ marginRight: 5 }} key={JSON.stringify(value)}>
                                        {segundosToHorario(value.inicio)} às {segundosToHorario(value.termino)}</Flex>
                                })}
                            </Flex>
                        </Flex>
                        <Divider style={{ marginTop: 1, marginBottom: 1 }} />
                        <Flex justify='space-between' style={{ fontWeight: dayjs().day() === 5 ? 'bold' : 'normal' }}>
                            <Flex>Sexta</Flex>
                            <Flex gap={2}>
                                {app?.horarios?.filter(value => value.dia === 5).map((value, index) => {
                                    return <Flex style={{ marginRight: 5 }} key={JSON.stringify(value)}>
                                        {segundosToHorario(value.inicio)} às {segundosToHorario(value.termino)}</Flex>
                                })}
                            </Flex>
                        </Flex>
                        <Divider style={{ marginTop: 1, marginBottom: 1 }} />
                        <Flex justify='space-between' style={{ fontWeight: dayjs().day() === 6 ? 'bold' : 'normal' }}>
                            <Flex>Sábado</Flex>
                            <Flex gap={2}>
                                {app?.horarios?.filter(value => value.dia === 6).map((value, index) => {
                                    return <Flex style={{ marginRight: 5 }} key={JSON.stringify(value)}>
                                        {segundosToHorario(value.inicio)} às {segundosToHorario(value.termino)}</Flex>
                                })}
                            </Flex>
                        </Flex>
                        <Divider style={{ marginTop: 1, marginBottom: 1 }} />



                    </Flex>

                    <Flex style={{ fontWeight: 700, marginTop: 20, fontSize: '1.2em' }}>Tempo de Entrega Estimado</Flex>
                    <Flex align='center' gap={5}>
                        <ClockCircleFilled style={{ color: app?.cor }} />
                        <Flex>{app.entrega}</Flex>
                    </Flex>

                    <Flex style={{ fontWeight: 700, marginTop: 20, fontSize: '1.2em' }}>Endereço</Flex>
                    <Flex align='center' gap={10}>
                        <Flex>
                            <EnvironmentOutlined />
                        </Flex>
                        <Flex vertical>
                            <Flex> {app.endereco} {app.numero} {app.complemento}</Flex>
                            <Flex gap={3}>{app.bairro} - {app.cidade} / {app.uf}, Brasil</Flex>
                        </Flex>
                    </Flex>
                    <Divider style={{ marginTop: 5, marginBottom: 5 }} />
                    <div >
                        <Flex style={{
                            padding: 15, color: '#303030ff', textAlign: 'center', fontSize: '0.9em',

                        }} vertical justify='center' align='center' gap={5}>
                            <Flex>Crie seu menu digital com Leopos</Flex>
                            <Flex><span >Feito com muito ❤️ e ☕ por <span style={{ fontWeight: 500 }}>Engfood Serviços de Software</span></span></Flex>
                            <Flex>{dayjs().format("YYYY")} - Todos os direitos reservados</Flex>

                        </Flex>
                    </div>

                </Flex>
            </Drawer>

            {itemSelected &&
                <Drawer
                    width={'100%'}
                    id='dwrItem'
                    open={openSelected}
                    title={null}
                    onClose={() => setOpenSelected(false)}
                    destroyOnClose={true}
                    closable={false}
                    footer={
                        <Flex style={{ width: '100%' }} justify='space-between'>
                            <Flex justify='left'>
                                <Flex style={{
                                    borderWidth: 0.7, borderColor: 'lightgrey',
                                    borderRadius: 5, borderStyle: 'solid', marginRight: 30
                                }} align='center' gap={5}>
                                    <Button

                                        type='link' icon={<MinusOutlined />}
                                        onClick={() => {
                                            if (!itemSelected?.quant)
                                                itemSelected.quant = 0
                                            itemSelected.quant = itemSelected?.quant - 1
                                            if (itemSelected.quant <= 0)
                                                itemSelected.quant = 1
                                            setItemSelected({ ...itemSelected })
                                        }} />
                                    <Flex style={{ width: 30, fontSize: '1.2em', fontWeight: 'bold', color: app?.cor }} justify='center'> {itemSelected?.quant}</Flex>
                                    <Button

                                        type='link' icon={<PlusOutlined />}
                                        onClick={() => {
                                            if (!itemSelected?.quant)
                                                itemSelected.quant = 0
                                            itemSelected.quant = itemSelected?.quant + 1
                                            setItemSelected({ ...itemSelected })
                                        }} />
                                </Flex>
                            </Flex>
                            <Flex flex={1} >
                                <Button
                                    style={{ backgroundColor: app?.cor }}
                                    type='primary'
                                    block
                                    disabled={!selectedValided}
                                    onClick={() => {
                                        if (app.status?.open === true) {
                                            addItem(itemSelected)
                                            setItemSelected(undefined)
                                        }
                                        else
                                            addToast("O estabelecimento está fechado, não é possível efetuar o pedido!", { appearance: 'info', autoDismiss: true })

                                    }}>
                                    <Flex align='center' gap={8}>
                                        <Flex style={{ fontWeight: 'bold' }}>ADICIONAR</Flex>
                                        <Flex>R$ {sumItem()}</Flex>
                                    </Flex>
                                </Button>
                            </Flex>
                        </Flex>
                    }>
                    <Flex vertical gap={5}>
                        {
                            itemSelected?.url && <Image
                                placeholder={<Placeholder.Graph active />}
                                src={itemSelected.url} width={'100%'} />
                        }

                        <div style={{ position: 'absolute', marginLeft: 20, marginTop: itemSelected?.url ? 20 : 40 }}>
                            <Avatar style={{ backgroundColor: 'gray' }} icon={<LeftOutlined style={{ color: 'white' }} />}
                                onClick={() => setOpenSelected(false)} />
                        </div>
                        <Flex style={{ paddingLeft: 10, paddingTop: 10, paddingRight: 10 }} vertical>
                            <Flex style={{ fontWeight: 600, color: '#373737ff', fontSize: '1.3em', marginTop: 9 }}>{itemSelected.name}</Flex>
                            <Flex wrap style={{ color: 'gray' }}>{itemSelected?.note}</Flex>
                            {itemSelected.value > 0 &&
                                renderPreco(itemSelected)}

                        </Flex>

                        <Flex style={{ width: '100%', marginTop: 10 }} vertical>
                            {
                                itemSelected?.groups?.map((gp, indexgp) => {
                                    return <Flex vertical key={"gp".concat(indexgp)} style={{ width: '100%' }}>
                                        <Flex style={{
                                            fontSize: '1em', fontWeight: 600, marginLeft: 5, backgroundColor: 'whitesmoke',
                                            padding: 8, paddingLeft: 15, marginBottom: 10
                                        }}
                                            gap={10} align='center'>
                                            <Flex justify='space-between' align='center' style={{ width: '100%' }}>
                                                <Flex align='center'>
                                                    <Flex vertical>
                                                        <Flex>{gp.name} </Flex>
                                                        <Flex style={{ fontSize: '0.75em', color: "#757575ff" }}> {gp.minimum <= gp.maximum ? "Escolha " : "Escolha até "} {gp.maximum} {gp.maximum === 1 ? "opção" : "opções"}</Flex>
                                                    </Flex>
                                                    <Tag style={{ marginLeft: 15, fontSize: '0.8em' }} color={gp.minimum > 0 ? app?.cor : 'default'} > {gp.mandatory > 0 ? 'obrigatório' : 'opcional'}</Tag>
                                                </Flex>
                                                <Flex vertical style={{ marginRight: 20, color: 'royalblue' }}>
                                                    {(gp.mandatory > 0 && gp.valided) && <CheckOutlined />}
                                                </Flex>


                                            </Flex>
                                        </Flex>
                                        <Flex gap={2} style={{ width: '100%' }} vertical>
                                            {
                                                gp.items?.map((gpi, indexgpi) => {
                                                    return <Flex vertical>
                                                        <Flex justify='space-between' key={'gpi'.concat(gpi.groupsitems_id)}
                                                            style={{ paddingLeft: 30, cursor: 'pointer' }}
                                                            onClick={() => {
                                                                // console.log(gpi)
                                                                let indexTemp = -1
                                                                if (gp.maximum === 1) {
                                                                    gp.items?.map((gpi, indexgpi) => {
                                                                        if (gpi.sel === 1)
                                                                            indexTemp = indexgpi
                                                                        return gpi.sel = 0
                                                                    })
                                                                    if (indexTemp !== indexgpi)
                                                                        gpi.sel = 1
                                                                    setItemSelected({ ...itemSelected })
                                                                }
                                                                if (gp.mandatory > 0) {
                                                                    const somaSel = gp.items.reduce((acumulador, current) => acumulador + (current.sel ? current.sel : 0), 0)
                                                                    if (gp.minimum <= somaSel)
                                                                        gp.valided = true
                                                                    else
                                                                        gp.valided = false
                                                                }

                                                            }}>
                                                            <Flex style={{ color: "#757575ff" }} gap={15}>
                                                                {gpi.name} {gpi.value > 0 && <span style={{ marginLeft: 5 }}>+ R$
                                                                    {parseFloat(gpi?.value).toFixed(2)}
                                                                </span>}
                                                            </Flex>
                                                            <Flex style={{ paddingRight: 15 }}> {
                                                                gp.maximum === 1 ? <Radio checked={gpi.sel === 1 ? true : false}></Radio> :
                                                                    <Flex align='center' >
                                                                        <Button type='link' style={{ display: gpi.sel > 0 ? 'block' : 'none' }} icon={<MinusOutlined />}
                                                                            onClick={() => {
                                                                                if (gpi.sel === undefined)
                                                                                    gpi.sel = 0
                                                                                gpi.sel = gpi.sel - 1
                                                                                if (gpi.sel < 0)
                                                                                    gpi.sel = 0

                                                                                if (gp.mandatory > 0) {
                                                                                    const somaSel = gp.items.reduce((acumulador, current) => acumulador + (current.sel ? current.sel : 0), 0)
                                                                                    if (gp.minimum <= somaSel)
                                                                                        gp.valided = true
                                                                                    else
                                                                                        gp.valided = false
                                                                                }
                                                                                setItemSelected({ ...itemSelected })
                                                                            }}
                                                                        />
                                                                        <Flex style={{ width: 30, display: gpi.sel > 0 ? 'block' : 'none', textAlign: 'center' }} justify='center'>{gpi.sel}</Flex>
                                                                        <Button type='link' icon={<PlusOutlined />}
                                                                            onClick={() => {
                                                                                const somaSel = gp.items.reduce((acumulador, current) => acumulador + (current.sel ? current.sel : 0), 0)
                                                                                if (somaSel >= gp.maximum)
                                                                                    return
                                                                                if (gpi.sel === undefined)
                                                                                    gpi.sel = 0
                                                                                gpi.sel = gpi.sel + 1
                                                                                if (gpi.sel < 0)
                                                                                    gpi.sel = 0
                                                                                setItemSelected({ ...itemSelected })
                                                                            }} />
                                                                    </Flex>
                                                            }
                                                            </Flex>

                                                        </Flex>
                                                        <Divider style={{ marginBottom: 5, marginTop: 4 }} />
                                                    </Flex>

                                                })
                                            }
                                        </Flex>
                                    </Flex>
                                })
                            }
                        </Flex>

                        <Divider style={{ marginTop: 2, marginBottom: 5 }} />
                        <Flex vertical style={{ padding: 12 }}>
                            <Flex justify='space-between' >
                                <Flex align='center' gap={10}>
                                    <CommentOutlined />
                                    Alguma Observação?
                                </Flex>
                                <Flex align='center' style={{ color: 'gray' }}>
                                    0/140
                                </Flex>
                            </Flex>
                            <Input.TextArea
                                autoSize
                                maxLength={140}
                                style={{ marginTop: 5, marginBottom: 20 }}
                                value={itemSelected?.obs}
                                onChange={(e) => setItemSelected({ ...itemSelected, obs: e.target.value })} />
                        </Flex>

                    </Flex>

                </Drawer>
            }
        </div>



    </div>








}



export default Delivery